module.exports = __webpack_public_path__ + "img/form-logo.png";